<div class="icon-container" (click)="openDialog()">
    <i class="pi pi-info-circle icon"></i>
</div>

<p-confirmDialog #cd>
    <ng-template pTemplate="footer">
        <button type="button" pButton class="p-button-rounded btn-modak btn-green-primary-nonline" label="{{ 'SHARED.GO_BACK' | translate }}" (click)="cd.reject()"></button>
        <button type="button" pButton class="p-button-rounded btn-modak btn-green-primary-nonline" label="{{ 'SHARED.CONTACT_SUPPORT' | translate }}" (click)="cd.accept()"></button>
    </ng-template>
  </p-confirmDialog>